import { PAGES } from 'routes'

export const BREADCRUMBS = {
  DASHBOARD: {
    href: PAGES.DASHBOARD,
  },
  STAKING: {
    title: 'Staking',
  },
  STAKING_TOKEN: {
    title: 'Staking Token',
  },
  STAKING_TOKEN_DETAIL: {
    title: 'Staking Token Detail',
  },
  STAKING_NFT: {
    title: 'Staking NFTs',
  },
  STAKING_ERC3643: {
    title: 'Staking ERC-3643',
    href: PAGES.STAKING_ERC3643,
  },
  STAKING_ERC3643_POOL_LIST: {
    title: 'Pool List',
  },
  STAKING_ERC3643_POOL_DETAIL: {
    title: 'Pool Detail',
  },
  STAKING_NFT_PTO: {
    title: 'List PTO',
  },
  POOL_DETAIL: {
    title: 'Staking Detail',
  },
  SETTING: {
    title: 'Setting',
  },
  STAKING_TOKEN_CONFIG: {
    title: 'Staking Token Config',
  },
  TRANSACTION_HISTORY: { title: 'Transaction History' },
  AFFILIATES: { title: 'Affiliates' },
  AFFILIATES_TREE: { title: 'Affiliates Tree' },
  LOG: { title: 'Log' },
  USER: { title: 'User' },
  USER_MEY_REAL: { title: 'User (Mey Real)' },
  P2P: { title: 'P2P Lending', href: PAGES.P2P_LENDING },
  P2P_NO_LINK: { title: 'P2P Lending', href: PAGES.P2P_LENDING },
  P2P_CREATE_NO_LINK: { title: 'P2P Create' },
  PTO: { title: 'PTO', href: PAGES.PTO },
  PTO_NO_LINK: { title: 'PTO', href: PAGES.PTO },
  PTO_CREATE_NO_LINK: { title: 'PTO Create' },
  PTO_V2: { title: 'PTO v2', href: PAGES.PTO_V2 },
  PTO_V2_CREATE_NO_LINK: { title: 'PTO v2 Create' },
  PTO_V3: { title: 'PTO ERC-3643', href: PAGES.PTO_V3 },
  PTO_V3_CREATE_NO_LINK: { title: 'PTO ERC-3643 Create' },
  PTO_REWARDS: { title: 'Rewards', href: PAGES.PTO_REWARDS },
  PTO_REFERRAL: { title: 'Referral Program', href: PAGES.PTO_REFERRAL },
  BOOSTER_PROGRAM: { title: 'Booster Program', href: PAGES.BOOSTER_PROGRAM },
  BOOSTER_PROGRAM_CREATE: { title: 'Create Booster Program' },
  BOOSTER_PROGRAM_DETAIL: { title: 'Booster Program Details' },
  PROMO_CODE: { title: 'Promo Code', href: PAGES.PROMO_CODE },
  PROPERTY_ACTIVITIES: { title: 'Property Activities', href: PAGES.PROPERTY_ACTIVITIES },
  PROPERTY_ACTIVITIES_NO_LINK: { title: 'Property Activities' },
  VESTING: { title: 'Vesting claim' },
  EMAIL: { title: 'Email' },
  EMAIL_V2: { title: 'Email V2' },
  BANNER: { title: 'Banner', href: PAGES.BANNER },
  VESTING_DATA: { title: 'Vesting Data', href: PAGES.ACCOUNT_VESTING_HMC },
  DAO_VOTING: { title: 'DAO Voting', href: PAGES.DAO_VOTING },
  DAO_VOTING_NO_LINK: { title: 'DAO Voting' },
  WHATS_NEW: { title: "What's New", href: PAGES.WHATS_NEW },
  FAQ: { title: 'FAQ Management', href: PAGES.FAQ },
  FAQ_ARTICLE_CREATE: { title: 'Create Article' },
}

export const AFFILIATES_TABS = {
  COMMISSION: 'commission',
  REFERRAL_USER: 'referralUser',
}
